import { INTER_FONT_FEATURE_SETTINGS } from "../../constants";

const BOLD_TITLE_WEIGHT = '"wght" 700';
const TITLE_WEIGHT = '"wght" 600';
const BODY_WEIGHT = '"wght" 500';
const REGULAR_WEIGHT = '"wght" 400';
const TITLE_SPACING = "-0.04em";
const BODY_SPACING = "-0.02em";
const BRONZEA_FONT_FAMILY = "var(--font-bronzea)";
const FLECHA_FONT_FAMILY = "var(--font-flecha)";
const SPACE_MONO_FONT_FAMILY = "var(--font-space-mono)";

export const fontWeightMap = {
  BOLD: BOLD_TITLE_WEIGHT,
  TITLE: TITLE_WEIGHT,
  BODY: BODY_WEIGHT,
  REGULAR: REGULAR_WEIGHT,
};

const DisplayXL = {
  fontSize: 224,
  textTransform: "uppercase" as const,
  lineHeight: "179.2px",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing: "-11.2px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const DisplayL = {
  fontSize: 176,
  textTransform: "uppercase",
  lineHeight: "0.8",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-3.52px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const EVPDisplayL = {
  fontSize: 72,
  lineHeight: "61.2px",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: "-3.6px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const EVPDisplayLMobile = {
  fontSize: 56,
  lineHeight: "47.6px",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: "-2.8px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const DisplayLTablet = {
  fontSize: "clamp(96px, calc(-1.5591rem + 15.748vw), 136px) !important",
  textTransform: "uppercase",
  lineHeight: "0.8",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing: "clamp(-6.8px, calc(0.078rem + -0.7874vw), -4.8px) !important",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const DisplayM = {
  fontSize: 144,
  lineHeight: "0.8",
  textTransform: "uppercase",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-2.88px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const EVPDisplayM = {
  fontSize: "clamp(44px, 0.0991rem + 4.142vw, 72px) !important",
  lineHeight: "130%",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: "-2.56px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const EVPDisplayMMobile = {
  fontSize: 36,
  lineHeight: "130%",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: "-1.44px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const DisplayMTablet = {
  fontSize: "clamp(88px, calc(0.9646rem + 9.4488vw), 112px) !important",
  textTransform: "uppercase",
  lineHeight: "0.8",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing:
    "clamp(-5.6px, calc(-0.0482rem + -0.4724vw), -4.4px) !important",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const DisplayS = {
  fontSize: 112,
  lineHeight: "0.8",
  textTransform: "uppercase",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-2.24px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const DisplaySTablet = {
  fontSize: "clamp(80px, calc(1.9764rem + 6.2992vw), 96px) !important",
  textTransform: "uppercase",
  lineHeight: "0.8",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing: "clamp(-4.8px, calc(-0.0988rem + -0.315vw), -4px) !important",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const DisplayMobile = {
  fontSize: "clamp(48px, calc(1.3475rem + 6.594vw), 72px) !important",
  textTransform: "uppercase",
  lineHeight: "0.8",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing:
    "clamp(-3.6px, calc(-0.0674rem + -0.3297vw), -2.4px) !important",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const TitleL = {
  fontSize: 72,
  lineHeight: "72px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-1.44px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const TitleM = {
  fontSize: 48,
  lineHeight: "48px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-0.96px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const TitleS = {
  fontSize: 36,
  lineHeight: "36px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-0.72px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const SubTitleL = {
  fontSize: 30,
  lineHeight: "36px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-0.6px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const SubTitleM = {
  fontSize: 24,
  lineHeight: "29px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-0.48px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const SubTitleS = {
  fontSize: 20,
  lineHeight: "24px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-0.4px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const EVPSubTitleS = {
  fontSize: 21,
  lineHeight: "1.4",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: "-0.42px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const SubTitleSRegular = {
  fontSize: 20,
  lineHeight: "24px",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing: "-0.4px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const BodyL = {
  fontSize: 16,
  lineHeight: "24px",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing: "-0.32px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const BodyM = {
  fontSize: 14,
  lineHeight: "21px",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing: "-0.28px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const BodyS = {
  fontSize: 12,
  lineHeight: "18px",
  fontVariationSettings: REGULAR_WEIGHT,
  letterSpacing: "-0.24px",
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const Legal = {
  fontSize: 10,
  lineHeight: "15px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontFeatureSettings: INTER_FONT_FEATURE_SETTINGS,
};

const FlechaL = {
  fontSize: 72,
  lineHeight: "80px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaM = {
  fontSize: 48,
  lineHeight: "54px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaS = {
  fontSize: 36,
  lineHeight: "40px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaXS = {
  fontSize: 24,
  lineHeight: "26px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const SpaceMonoL = {
  fontSize: 24,
  lineHeight: "29px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontFamily: SPACE_MONO_FONT_FAMILY,
  textTransform: "uppercase" as const,
  fontVariantLigatures: "none",
};

const SpaceMonoM = {
  fontSize: 20,
  lineHeight: "24px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontFamily: SPACE_MONO_FONT_FAMILY,
  textTransform: "uppercase" as const,
  fontVariantLigatures: "none",
};

const SpaceMonoS = {
  fontSize: 16,
  lineHeight: "19px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontFamily: SPACE_MONO_FONT_FAMILY,
  textTransform: "uppercase" as const,
  fontVariantLigatures: "none",
};

const SpaceMonoBodyS = {
  fontSize: 16,
  lineHeight: "23px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontFamily: SPACE_MONO_FONT_FAMILY,
  letterSpacing: "-0.64px",
  fontVariantLigatures: "none",
};

const SpaceMonoXS = {
  fontSize: 12,
  lineHeight: "14px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontFamily: SPACE_MONO_FONT_FAMILY,
  textTransform: "uppercase" as const,
  fontVariantLigatures: "none",
};

const Display1 = {
  fontSize: 96,
  lineHeight: "104px",
  fontVariationSettings: BOLD_TITLE_WEIGHT,
  letterSpacing: TITLE_SPACING,
};

const Display2 = {
  fontSize: 80,
  lineHeight: "88px",
  fontVariationSettings: BOLD_TITLE_WEIGHT,
  letterSpacing: TITLE_SPACING,
};

const Display3 = {
  fontSize: 64,
  lineHeight: "72px",
  fontVariationSettings: BOLD_TITLE_WEIGHT,
  letterSpacing: TITLE_SPACING,
};

const Headline1 = {
  fontSize: 56,
  lineHeight: "64px",
  fontVariationSettings: BOLD_TITLE_WEIGHT,
  letterSpacing: TITLE_SPACING,
};

const Headline2 = {
  fontSize: 40,
  lineHeight: "52px",
  fontVariationSettings: BOLD_TITLE_WEIGHT,
  letterSpacing: TITLE_SPACING,
};

const Headline3 = {
  fontSize: 32,
  lineHeight: "40px",
  fontVariationSettings: BOLD_TITLE_WEIGHT,
  letterSpacing: BODY_SPACING,
};

const Headline3R = {
  ...Headline3,
  fontVariationSettings: REGULAR_WEIGHT,
  /** NOTE: "wght 400" doesn't overwrite the original
   * font weight style of h3 */
  fontWeight: 400,
};

const Headline4 = {
  fontSize: 24,
  lineHeight: "32px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: BODY_SPACING,
};

const Headline4R = {
  ...Headline4,
  fontVariationSettings: REGULAR_WEIGHT,
  /** NOTE: "wght 400" doesn't overwrite the original
   * font weight style of h3 */
  fontWeight: 400,
};

const HeadingExtraSmall = {
  fontSize: 20,
  lineHeight: "28px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: TITLE_SPACING,
};

const Subtitle1 = {
  fontSize: 20,
  lineHeight: "28px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: BODY_SPACING,
};

const Subtitle2 = {
  fontSize: 16,
  lineHeight: "20px",
  fontVariationSettings: TITLE_WEIGHT,
  letterSpacing: BODY_SPACING,
};

const Body0 = {
  fontSize: 20,
  lineHeight: "32px",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: BODY_SPACING,
};

const Body1 = {
  fontSize: 16,
  lineHeight: "24px",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: BODY_SPACING,
};

const Body2 = {
  fontSize: 14,
  lineHeight: "20px",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: BODY_SPACING,
};

const Button = {
  fontSize: 14,
  lineHeight: "16px",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: BODY_SPACING,
};

export const Caption = {
  fontSize: 12,
  lineHeight: "16px",
  fontVariationSettings: BODY_WEIGHT,
  letterSpacing: BODY_SPACING,
};

// Bronzea Sizes
const BronzeaTitle1 = {
  fontSize: 264,
  lineHeight: "264px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaTitle2 = {
  fontSize: 192,
  lineHeight: "192px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaDisplay1 = {
  fontSize: 114,
  lineHeight: "114px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaDisplay2 = {
  fontSize: 94,
  lineHeight: "94px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaDisplay3 = {
  fontSize: 64,
  lineHeight: "72px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaDisplay4 = {
  fontSize: 56,
  lineHeight: "64px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaDisplay5 = {
  fontSize: 48,
  lineHeight: "56px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaDisplay6 = {
  fontSize: 36,
  lineHeight: "36px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

const BronzeaDisplay7 = {
  fontSize: 24,
  lineHeight: "24px",
  fontFamily: BRONZEA_FONT_FAMILY,
};

// Flecha Sizes
const FlechaDisplay1 = {
  fontSize: 64,
  lineHeight: "64px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaDisplay2 = {
  fontSize: 56,
  lineHeight: "56px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaDisplay3 = {
  fontSize: 48,
  lineHeight: "48px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaDisplay4 = {
  fontSize: 36,
  lineHeight: "36px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaDisplay5 = {
  fontSize: 24,
  lineHeight: "24px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaDisplay5R = {
  ...FlechaDisplay5,
  lineHeight: "32px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontWeight: 400,
};

const FlechaDisplay6 = {
  fontSize: 18,
  lineHeight: "18px",
  fontVariationSettings: BODY_WEIGHT,
  fontFamily: FLECHA_FONT_FAMILY,
};

const FlechaDisplay6R = {
  ...FlechaDisplay6,
  lineHeight: "24px",
  fontVariationSettings: REGULAR_WEIGHT,
  fontWeight: 400,
};

export default {
  DisplayXL,
  DisplayL,
  EVPDisplayL,
  EVPDisplayLMobile,
  DisplayLTablet,
  DisplayM,
  EVPDisplayM,
  EVPDisplayMMobile,
  DisplayMTablet,
  DisplayS,
  DisplaySTablet,
  DisplayMobile,
  TitleL,
  TitleM,
  TitleS,
  SubTitleL,
  SubTitleM,
  SubTitleS,
  EVPSubTitleS,
  SubTitleSRegular,
  BodyL,
  BodyM,
  BodyS,
  Legal,
  FlechaL,
  FlechaM,
  FlechaS,
  FlechaXS,
  SpaceMonoL,
  SpaceMonoM,
  SpaceMonoS,
  SpaceMonoXS,
  SpaceMonoBodyS,
  Display1,
  Display2,
  Display3,
  Headline1,
  Headline2,
  Headline3,
  Headline3R,
  Headline4,
  Headline4R,
  HeadingExtraSmall,
  Subtitle1,
  Subtitle2,
  Body0,
  Body1,
  Body2,
  Caption,
  Button,
  BronzeaTitle1,
  BronzeaTitle2,
  BronzeaDisplay1,
  BronzeaDisplay2,
  BronzeaDisplay3,
  BronzeaDisplay4,
  BronzeaDisplay5,
  BronzeaDisplay6,
  BronzeaDisplay7,
  FlechaDisplay1,
  FlechaDisplay2,
  FlechaDisplay3,
  FlechaDisplay4,
  FlechaDisplay5,
  FlechaDisplay5R,
  FlechaDisplay6,
  FlechaDisplay6R,
};
